(function ($) {
    //TODO: convertir todo a jquery
    //TODO: que se ejecute tambien al hacer grande el resize
    if($(".breadcrumbs").length){
        calculateBreadcrumb();
    }

    $(window).on("resize", () => {
        if($(".breadcrumbs").length){
            calculateBreadcrumb();
        }
    });

    function calculateBreadcrumb(){
        const textElements = document.querySelectorAll('.breadcrumbs .breadcrumbs__item .breadcrumbs__text');
        const dotsElement = document.querySelector('.three-points');

        textElements.forEach(textElement => {
            var textRect = $(textElement)[0].getBoundingClientRect();

            if($(textElement).find(".three").length){
                childRect = $(textElement).find(".three")[0].getBoundingClientRect();
                textRect.left = textRect.left - childRect.left;
                textRect.right = textRect.right - childRect.right;
                textRect.width -= childRect.width;
            }

            const dotsRect = dotsElement.getBoundingClientRect();
            const isFullyOverlapping = dotsRect.left < textRect.right && dotsRect.right > textRect.left;

            if($(textElement).data("fullname") == undefined){
                $(textElement).data("fullname", textElement.textContent);
            }

            if (isFullyOverlapping) {              
                if($(textElement).find(".croppedChars").length){
                    childRect = $(textElement).find(".croppedChars")[0].getBoundingClientRect();
                    textRect.left -= childRect.left;
                    textRect.right -= childRect.right;
                    textRect.width -= childRect.width;
                }

                isOverlappingTheRest = dotsRect.left < textRect.right && dotsRect.right > textRect.left;

                if(isOverlappingTheRest){
                    const coveredWidth = textRect.right - dotsRect.left;
                
                    const textContent = $(textElement).clone().children().remove().end().text();
                    const charWidth = textRect.width / textContent.length; // Ancho aproximado de cada carácter
                    const charsToHide = Math.ceil(coveredWidth / charWidth); // Número de caracteres que cubren los puntos
                    
                    textElement.textContent = textContent.slice(0, -charsToHide);
                    textsDifferences = $(textElement).data("fullname").length - $(textElement).clone().children().remove().end().text().length;

                    if(!$(textElement).find(".three").length){
                        $(textElement).append('<span class="three">...</span>');
                    }

                    if(!$(textElement).find(".croppedChars").length){
                        $(textElement).append('<span class="croppedChars"></span>');  
                    }

                    $(textElement).find(".croppedChars").html( $(textElement).data("fullname").slice( -(textsDifferences) ));
                }
            }else{
                textElement.textContent = $(textElement).data("fullname");

                if($(textElement).find(".three").length){
                    $(textElement).find(".three").remove();
                }

                if($(textElement).find(".croppedChars").length){
                    $(textElement).find(".croppedChars").remove();
                }
            }
        });  
    }
})(jQuery);